import { Button } from "./components/Button";
import { Dialog } from "./components/Dialog";
export { Provider as RefDialogProvider, RefDialogContext } from "./components/Provider";
export { useRefDialog } from "./hooks/useRefDialog";
export * from "./types";
export const RefDialog = Object.assign(Dialog, {
    Button: Button
});
//# sourceMappingURL=index.js.map